import { Dispatch, SetStateAction, useEffect, useState } from 'react';

export default function useLocalStorage(
  key: string,
  defaultValue: string,
  session: boolean = false
): [string | undefined, Dispatch<SetStateAction<string | undefined>>] {
  const [value, setValue] = useState<string | undefined>(undefined);

  // Initialize the value from the cookie
  useEffect(() => {
    const initialValue = session
      ? sessionStorage.getItem(key)
      : localStorage.getItem(key);
    setValue(initialValue ?? defaultValue);
  }, [key, defaultValue, session]);

  // Update the cookie when the value changes
  useEffect(() => {
    if (typeof value === 'string') {
      if (session) {
        sessionStorage.setItem(key, value);
      } else {
        localStorage.setItem(key, value);
      }
    }
  }, [value, key, session]);

  return [value, setValue];
}
